import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const caitlynPlugin = createPlugin({
  id: 'caitlyn',
  routes: {
    root: rootRouteRef,
  },
});

export const CaitlynPage = caitlynPlugin.provide(
  createRoutableExtension({
    name: 'CaitlynPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
